import { View } from 'react-native';
import styled from 'styled-components/native';
const Grid = styled(View) `
  flex: 1;
  flex-basis: auto;
`;
export default Grid;
